<script setup lang="ts">
import { onMounted, onUnmounted, useTemplateRef } from 'vue';

import SpecialOptionsStepNewAirRoadSection from '@/components/sections/SpecialOptionsStepNewAirRoadSection.vue';
import { useNewAirRoadViewStore } from '@/stores/useNewAirRoadViewStore';
import * as airRoadConstants from '@/constants/airRoad';

const newAirRoadViewStore = useNewAirRoadViewStore();

const specialOptionsFormRef =
  useTemplateRef<HTMLFormElement>('specialOptionsForm');

onMounted(function () {
  newAirRoadViewStore.setSpecialOptionsFormElement(specialOptionsFormRef.value);
});

onUnmounted(function () {
  newAirRoadViewStore.setSpecialOptionsFormElement(null);
});
</script>

<template>
  <v-form
    ref="specialOptionsForm"
    v-model="
      newAirRoadViewStore.bookingStepValidationState[
        airRoadConstants.bookingStepValues.SPECIAL_OPTIONS
      ]
    "
    :class="$style.specialOptionsNewAirRoadStepForm"
    data-testid="specialOptionsNewAirRoadStepForm"
    validate-on="lazy"
  >
    <input type="submit" class="hidden" disabled />
    <SpecialOptionsStepNewAirRoadSection
      v-model="newAirRoadViewStore.bookingState"
      :air-road-booking-job="newAirRoadViewStore.data.airRoadBookingJob"
    />
  </v-form>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.specialOptionsNewAirRoadStepForm {
}
</style>
